import * as React from 'react'

import { Step as AuthModalStep } from 'main/components/common/AuthModal'
import { User_user } from 'main/gql/user'
import { UnreachableCaseError } from 'main/util/ts'
import { userType, UserType } from 'main/util/user'

import AnonymousLinks from './AnonymousLinks'
import DirectorLinks from './DirectorLinks'
import { Container } from './Links.styles'
import ParentLinks from './ParentLinks'

interface IProps {
  user: User_user | null
  onRequestOpenAuthModal: (initialStep: AuthModalStep) => void
}

function Links(props: IProps) {
  const { user, onRequestOpenAuthModal } = props

  return (
    <Container>
      {user ? (
        <LoggedIn user={user} />
      ) : (
        <AnonymousLinks onRequestOpenAuthModal={onRequestOpenAuthModal} />
      )}
    </Container>
  )
}

function LoggedIn(props: { user: User_user }) {
  const { user } = props
  const upeEnabled = window.lego && window.lego.upeEnabled
  const type = userType(user)

  switch (type) {
    case UserType.Director:
      return (
        <DirectorLinks
          isOnboarding={user.schoolhouse!.isOnboarding}
          currentOnboardingSlug={user.schoolhouse!.currentOnboardingSlug}
        />
      )
    case UserType.Parent:
      return upeEnabled ? <></> : <ParentLinks />
    default:
      throw new UnreachableCaseError(type)
  }
}

export default React.memo(Links)
